"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _prefix = _interopRequireDefault(require("../prefix"));

var _FormGroup = _interopRequireDefault(require("react-bootstrap/lib/FormGroup"));

var _Checkbox = _interopRequireDefault(require("react-bootstrap/lib/Checkbox"));

var _HelpBlockContainer = _interopRequireDefault(require("../internal/HelpBlockContainer"));

var _Label = _interopRequireDefault(require("../internal/Label"));

var _useIncomingError = _interopRequireDefault(require("../internal/hooks/useIncomingError"));

var _states = require("../internal/validation/states");
/**
Independently selectable checkbox items within a list
 */


var CheckBoxList = function CheckBoxList(_ref) {
  var className = _ref.className,
      displayLabel = _ref.displayLabel,
      hasError = _ref.hasError,
      errorMessage = _ref.errorMessage,
      htmlId = _ref.htmlId,
      inline = _ref.inline,
      label = _ref.label,
      layout = _ref.layout,
      name = _ref.name,
      onChange = _ref.onChange,
      options = _ref.options,
      required = _ref.required,
      values = _ref.values;

  var _useState = (0, _react.useState)(values || []),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useState3 = (0, _react.useState)(_states.validState),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      validationState = _useState4[0],
      setValidationState = _useState4[1];

  (0, _react.useEffect)(function () {
    values && setSelected(values);
  }, [values]);
  (0, _useIncomingError["default"])(errorMessage, hasError, setValidationState);

  var onCheckboxChange = function onCheckboxChange(event) {
    var _event$target = event.target,
        checked = _event$target.checked,
        value = _event$target.value;
    var selectedValues = checked ? [].concat((0, _toConsumableArray2["default"])(selected), [value]) : selected.filter(function (each) {
      return each !== value;
    });
    var isValid = checkboxListIsValid(selectedValues);
    onChange({
      target: {
        name: name,
        value: selectedValues
      }
    }, isValid, event);
    setValidationState(isValid ? _states.validState : (0, _states.requiredErrorState)(label));
    setSelected(selectedValues);
  };

  var checkboxListIsValid = function checkboxListIsValid(values) {
    return required && !values.length ? false : true;
  };

  var checkboxes = options.map(function (_ref2) {
    var label = _ref2.label,
        disabled = _ref2.disabled,
        value = _ref2.value,
        title = _ref2.title;
    var checked = values && values.indexOf(value) > -1;
    var id = "".concat(htmlId, "-").concat(label.replace(/\s/g, ""));
    var key = "".concat(htmlId, "-").concat(value.replace(/\s/g, ""));
    return /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      bsClass: "".concat(_prefix["default"], "checkbox"),
      className: "cx-checkbox",
      id: id,
      inline: inline,
      key: key,
      onChange: onCheckboxChange,
      title: title,
      checked: checked,
      disabled: disabled,
      name: name,
      value: value
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "cx-checkbox__label"
    }, label), /*#__PURE__*/_react["default"].createElement("div", {
      className: "cx-checkbox__checkmark"
    }));
  });
  return /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
    bsClass: "".concat(_prefix["default"], "form-group"),
    className: (0, _classnames["default"])([className, layout === "horizontal" && "input-side-by-side"]),
    controlId: htmlId,
    validationState: validationState.type
  }, displayLabel && /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    className: (0, _classnames["default"])(className, {
      inline: inline
    }),
    htmlId: "".concat(htmlId, "-label"),
    required: required
  }, label), inline ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "cx-checkboxes"
  }, checkboxes) : checkboxes, validationState.type && /*#__PURE__*/_react["default"].createElement(_HelpBlockContainer["default"], {
    message: validationState.msg,
    status: validationState.type
  }));
};

CheckBoxList.defaultProps = {
  displayLabel: true,
  inline: false,
  layout: "vertical"
};
var _default = CheckBoxList;
exports["default"] = _default;